module.exports = __webpack_public_path__ + "static/media/logo_homemade-tokyo.ca6eefe0.png";